import parse from "html-react-parser"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"
import { bold } from "css/text"
import { Icon } from "components/icon/Icon"
import { contrastMode } from "css/a11y"

const Root = styled.div`
  text-align: end;
  margin-block: 40px;
  margin-inline-end: var(--outer-margin);
  inset-inline-end: 0;
  z-index: 51;
  /* position: absolute; */

  ${contrastMode}

  &.dark-theme {
    color: rgb(var(--pure-white));
  }
`

const P = styled.p`
  & b,
  & time {
    ${bold}
  }
  & svg {
    margin-inline-start: 0.5rem;
    margin-block-end: -0.1rem;
  }
`

export default function ReadingInfo({ publish_date, minutes_to_read, seconds_to_read, theme }) {
  const console = useConsole()
  const dictionary = useDictionary()

  const [year, month] = publish_date.split("-")

  const pubDate = dictionary.publishDate(publish_date, dictionary[`month${month}`](), year)

  return (
    <Root className={theme || "ligth-theme"}>
      <P>{parse(pubDate)}</P>
      <span aria-label={dictionary.timeToReadAria(minutes_to_read, seconds_to_read)} />
      <P aria-hidden={true}>{parse(dictionary.timeToRead(minutes_to_read, seconds_to_read))}</P>
    </Root>
  )
}
